import { axios } from "../axios.instance";

export type ReadAllNotificationsRequest = null;

export type ReadAllNotificationsResponse = null;

export const readAllNotifications = async (): Promise<ReadAllNotificationsResponse> => {
  const { data } = await axios.post(`/notifications/read-all`);

  return data;
};
